export const parseDecimalNumber = (value = '') => {
  return value
    .replace(/\./g, '')
    .replace(/,/, '.')
    .replace(/[^0-9.]/g, '')
    .replace(/(\.\d{2}).*$/g, '$1')
}
